/** 最新位置の端末アイコン。MapLibre標準ピンと同じ表示サイズを使う。 */
export const DEVICE_MARKER_WIDTH = 27;
export const DEVICE_MARKER_HEIGHT = 41;
export const DEVICE_MARKER_IMAGE = 'assets/img/device-pin.png';

export function createDeviceMarkerElement(): HTMLElement {
  const element = document.createElement('div');
  element.style.width = `${DEVICE_MARKER_WIDTH}px`;
  element.style.height = `${DEVICE_MARKER_HEIGHT}px`;
  element.style.cursor = 'pointer';

  const image = document.createElement('img');
  image.src = new URL(DEVICE_MARKER_IMAGE, document.baseURI).toString();
  image.alt = '';
  image.style.width = '100%';
  image.style.height = '100%';
  image.style.display = 'block';
  image.style.position = 'relative';
  image.style.zIndex = '1';
  element.appendChild(image);
  return element;
}
